import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    INITIATE
} from 'one-state-receive-communication/src/types';

import {
    setStatus
} from 'one-state-receive-communication/src/actions';

import {
    ScreenpopModel
} from 'one-state-receive-communication/src/model';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';

import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
import axios from 'axios';
/**
 * This Fuction will intiate screenpop via get method to
 *  backend api and returns status
 * @param context contains the settings etc..
 */

 export const enum Types {
    
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToStatus = (payload: any) => setStatus(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });


export const fetchReceiveCommunicationEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { serverone, agentId, teamName, alertnotification, log, settings: { compatible, epicendpoints, servers,screenpop_config:{PhoneSystemID,PhoneSystemType} } } = context;
        const { locations = [] } = servers;
        const { apitoken } = epicendpoints;
        const { contact_center_type, finesse_proxy_service,screenpop_type } = compatible;
        return action$.pipe(
            ofType(INITIATE),
            // ofType(Types.PatientSet),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */

                let dataresponse: ScreenpopModel = action.payload;
                const getRequest = (payload: ScreenpopModel) => {

                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    headers.append("Accept", "application/json");
                    //  todo: delegate to one-server-ha oneview
                    headers.append("Content-Type", "text/plain");
                    let data = {}
                    // screenpop_type can be snap_adapter or receive_communication or receive_communication02 or receive_communication03
                    if(screenpop_type === "receive_communication")
                     data = {
                        "Context": payload?.context,
                        "UserID": payload?.agentId,
                        "UserIdType": payload?.useridtype,
                        "ContactType": payload?.contactType,
                        "CommunicationType": payload?.communicationType,
                        "PhoneNumber": payload?.phoneNumber,
                        "PatientInformationType": "",
                        "PatientInformation": "",
                        "CallID": payload?.callId,
                        "PatientID": {
                            "ID": payload?.patientId,
                            "Type": payload?.type
                        }
                    }
                    else if(screenpop_type === "receive_communication02") {
                        data = {
                            "Context": payload?.context,
                            "UserID": payload?.agentId,
                            "UserIdType": payload?.useridtype,
                            "LookupType": payload?.lookuptype,
                            "ContactType": payload?.contactType,
                            "CommunicationType": payload?.communicationType,
                            "PhoneNumber": payload?.phoneNumber,
                            "LookupInformationType": "",
                            "LookupInformation": "",
                            "CallID": payload?.callId,
                            "LookupID": payload?.patientId,
                            "LookupIDType": payload?.type
                        }
                    }
                    else if(screenpop_type === "receive_communication03") {
                        data = {
                            "Context": payload?.context,
                            "UserID": payload?.agentId,
                            "UserIdType": payload?.useridtype,
                            "LookupType": payload?.lookuptype,
                            "ContactType": payload?.contactType,
                            "CommunicationType": payload?.communicationType,
                            "CallerPhoneNumber": payload?.phoneNumber,
                            "LookupInformationType": "",
                            "LookupInformation": "",
                            "CallID": payload.callId,
                            "LookupID": payload?.patientId,
                            "LookupIDType": payload?.type,
                            "DialedPhoneNumber": payload?.DialedPhoneNumber,
                            "PhoneSystemID":PhoneSystemID,
                            "PhoneSystemType":PhoneSystemType,
                        }
                    }
                    let response;
                    if (finesse_proxy_service) {
                        response = InvokeFinesseProxy(epicendpoints?.receivecommunication, data, apitoken, locations, log, 'POST', alertnotification);

                    } else {
                        response = serverone.post({
                            path: epicendpoints?.receivecommunication,
                            data: data,
                            headers: headers
                        })
                            .then((responsefound: any) => {
                                // treating as success for screenpop

                                log.debug(
                                    "ccw-gadget,screenpop-epic",
                                    "screenpop-epic response", {
                                    responsefound
                                });
                                let result = responsefound;
                                return result;
                            })
                            .catch((responseresult: any) => {
                                //Check the Side B server receive communication
                                if (locations?.length >= 2) {
                                    const receivecommTwo = locations[1]?.base + epicendpoints?.receivecommunication;
                                    const token = 'Basic ' + apitoken?.token;
                                    const response = axios.post(`${receivecommTwo}`, data, {
                                        headers: {
                                            'Accept': 'application/json',
                                            'Authorization': token,
                                            'Content-Type': 'text/plain'
                                        }
                                    })
                                        .then((response: any) => {
                                            log.debug('Receive Communication SUCCESS: ', 'Agenta health check passed with status code:', response)
                                            return response;
                                        })
                                        .catch((response: any) => {
                                            if (payload?.agentId) {
                                                log.debug('Receive Communication ', 'Response', response);
                                                let alerterror: ErrorObject = {
                                                    source: "Receive Communication",
                                                    type: "error",
                                                    status: 400,
                                                    erroritems: [],
                                                    error_date: errorDate,
                                                    error_time: errorTime
                                                };

                                                // A brief description on how you can troubleshoot our two common errors seen here.
                                                console.error('Receive Communication ERROR: Unable to reach the Agenta server. If cert error (\'ERR_CERT_AUTHORITY_INVALID\'), browse the request URL and accept the certificate. If \'ERR_NAME_NOT_RESOLVED\', verify connection to UPMC server environment.');
                                                return alerterror;
                                            }
                                        });
                                    return response;
                                } else {
                                    log.error(
                                        "ccw-gadget,screenpop-epic",
                                        "screenpop-epic", {
                                        responseresult
                                    }
                                    );
                                    let result = responseresult;
                                    return result;
                                }
                            })
                    }
                    return from(response)

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => response)
                    ).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                pushToStatus(response)
                            ];
                            let disp: Disposition = { value: dataresponse.from };
                            if (contact_center_type && contact_center_type === "five9") {
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta01 = skillName;
                            }
                            else {
                                disp.meta01 = teamName;
                            }
                            disp.meta00 = agentId;
                            disp.meta02 = dataresponse?.patientId;
                            disp.meta03 = dataresponse?.context;
                            actions.push(pushToDisposition(disp));

                            if (response?.output?.success == true) {
                                let disp: Disposition = { value: "179" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.context;
                                disp.meta03 = dataresponse?.phoneNumber;
                                disp.meta04 = dataresponse?.patientId;
                                disp.meta05 = dataresponse?.type;
                                disp.meta06 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            else if (response?.output?.success == false && response?.output?.error?.length > 0) {
                                let errorarray = response?.output?.error;
                                errorarray.forEach((errordata: any) => {
                                    if (errordata?.display_text.includes("User is not logged in. Please login to Epic Hyperspace and try again.")) {
                                        let disp: Disposition = { value: "994" }
                                        if (contact_center_type && contact_center_type === 'five9') {
                                            let agentIdValue = sessionStorage.getItem("agentName");
                                            let skillName = sessionStorage.getItem("skillName");
                                            disp.meta00 = agentIdValue;
                                            disp.meta01 = skillName;
                                            disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                        } else {
                                            disp.meta00 = agentId;
                                            disp.meta01 = teamName;
                                            disp.dial_list_uid = state$.value.choosecaller?.callId;
                                        }
                                        disp.meta02 = dataresponse?.context;
                                        disp.meta03 = dataresponse?.phoneNumber;
                                        disp.meta04 = dataresponse?.patientId;
                                        disp.meta05 = dataresponse?.type;
                                        disp.meta06 = 'client';
                                        actions.push(pushToDisposition(disp));
                                    }
                                    else if (errordata?.display_text.includes("No user found with this ID. Please try again.")) {
                                        let disp: Disposition = { value: "995" }
                                        if (contact_center_type && contact_center_type === 'five9') {
                                            let agentIdValue = sessionStorage.getItem("agentName");
                                            let skillName = sessionStorage.getItem("skillName");
                                            disp.meta00 = agentIdValue;
                                            disp.meta01 = skillName;
                                            disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                        } else {
                                            disp.meta00 = agentId;
                                            disp.meta01 = teamName;
                                            disp.dial_list_uid = state$.value.choosecaller?.callId;
                                        }
                                        disp.meta02 = dataresponse?.context;
                                        disp.meta03 = dataresponse?.phoneNumber;
                                        disp.meta04 = dataresponse?.patientId;
                                        disp.meta05 = dataresponse?.type;
                                        disp.meta06 = 'client';
                                        actions.push(pushToDisposition(disp));
                                    }
                                    else {
                                        let disp: Disposition = { value: "996" }
                                        if (contact_center_type && contact_center_type === 'five9') {
                                            let agentIdValue = sessionStorage.getItem("agentName");
                                            let skillName = sessionStorage.getItem("skillName");
                                            disp.meta00 = agentIdValue;
                                            disp.meta01 = skillName;
                                            disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                        } else {
                                            disp.meta00 = agentId;
                                            disp.meta01 = teamName;
                                            disp.dial_list_uid = state$.value.choosecaller?.callId;
                                        }
                                        disp.meta02 = dataresponse?.context;
                                        disp.meta03 = dataresponse?.phoneNumber;
                                        disp.meta04 = dataresponse?.patientId;
                                        disp.meta05 = dataresponse?.type;
                                        disp.meta06 = 'client';
                                        actions.push(pushToDisposition(disp));
                                    }
                                })
                            }
                            if (response?.errors && response?.errors?.length > 0) {
                                let disp: Disposition = { value: "996" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = teamName;
                                disp.meta02 = dataresponse?.context;
                                disp.meta03 = dataresponse?.phoneNumber;
                                disp.meta04 = dataresponse?.patientId;
                                disp.meta05 = dataresponse?.type;
                                disp.meta06 = 'client';
                                actions.push(pushToDisposition(disp));
                                /*changes for errors will pushed to bell icon*/
                                let errorbuild: ErrorObject = {
                                    source: "Screenpop",
                                    type: "error",
                                    status: response?.status,
                                    erroritems: response?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                actions.push(addAction(errorbuild))
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);


